import { render } from "./tipleft.vue?vue&type=template&id=1b987068&scoped=true"
import script from "./tipleft.vue?vue&type=script&lang=js"
export * from "./tipleft.vue?vue&type=script&lang=js"

import "./tipleft.vue?vue&type=style&index=0&id=1b987068&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b987068"

export default script